export default class Float {
    static floatToIntBits(f) {
        return f;
    }
}
//# sourceMappingURL=Float.js.map